import { Clock } from 'lucide-react';
import { cn } from '../../lib/utils.ts';

export type Tone = 'ready' | 'check' | 'clarify' | 'waiting' | 'neutral';

/** Form des Zeichens je Stufe – steht auch als `data-mark` am Element (Prüfung „nicht Farbe allein“, Story 7.32). */
export const TONE_MARK_SHAPE = { ready: 'dot', check: 'triangle', clarify: 'square', waiting: 'clock', neutral: 'none' } as const;

/**
 * Zeichen der Ampel-Stufe (DESIGN „Status-Werte und Farbe“, Story 7.32): Bereit = runder Punkt, Prüfen = Dreieck mit
 * Ausrufezeichen, Klärfall = Quadrat mit Kreuz, Wartet = Uhr. Die Stufen sind so auch in Graustufen und für Menschen mit
 * Rot-Gelb-Schwäche an der Form zu unterscheiden; das Wort steht immer daneben (EXPERIENCE §5.1). Rein dekorativ
 * (`aria-hidden`), der Zustand steht im Text.
 */
export function ToneMark({ tone, className }: { tone: Tone; className?: string }) {
  const shape = TONE_MARK_SHAPE[tone];
  if (shape === 'none') return null;
  if (shape === 'clock') return <Clock aria-hidden data-mark={shape} size={13} strokeWidth={1.75} className={cn('flex-none', className)} />;
  if (shape === 'dot') return <span aria-hidden data-mark={shape} className={cn('size-2 flex-none rounded-full bg-ready', className)} />;
  if (shape === 'triangle') {
    return (
      <svg aria-hidden data-mark={shape} viewBox="0 0 12 12" width={12} height={12} className={cn('flex-none text-check-dot', className)}>
        <path d="M6 1 11.5 10.5H.5Z" fill="currentColor" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" />
        <path d="M6 4.6v2.6" stroke="var(--card)" strokeWidth="1.3" strokeLinecap="round" />
        <circle cx="6" cy="9" r=".75" fill="var(--card)" />
      </svg>
    );
  }
  return (
    <svg aria-hidden data-mark={shape} viewBox="0 0 12 12" width={12} height={12} className={cn('flex-none text-clarify', className)}>
      <rect x="0.5" y="0.5" width="11" height="11" rx="2" fill="currentColor" />
      <path d="M3.8 3.8l4.4 4.4M8.2 3.8 3.8 8.2" stroke="var(--card)" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
}
